<template>
  <LegalDocPage title="服务条款" :body-html="html" />
</template>

<script>
import LegalDocPage from '../components/LegalDocPage.vue'

const html = `
<h2>一、总则</h2>
<p>欢迎使用 Go Trust（以下简称“本平台”）。本平台由运营方（以下简称“我们”）向用户提供日本留学考学相关的课程浏览、下单购买、师生沟通、优惠活动等服务。您注册、登录或以其他方式使用本平台，即表示您已阅读并同意本《服务条款》。</p>
<p>如您不同意本条款任何内容，请立即停止使用本平台服务。</p>

<h2>二、账号与资格</h2>
<ul>
  <li>您应当使用本人真实、有效的手机号码完成注册与登录。</li>
  <li>您应妥善保管账号与验证码等信息，因保管不善导致的损失由您自行承担。</li>
  <li>学生端面向有留学考学需求的学习者；教师端面向经审核通过的辅导老师。不同端功能与权限可能不同。</li>
  <li>我们有权对虚假注册、恶意刷单、骚扰他人等行为采取限制、封禁等措施。</li>
</ul>

<h2>三、服务内容</h2>
<ul>
  <li>浏览课程、老师介绍与资讯内容；</li>
  <li>下单购买课程、支付、订单管理与售后沟通；</li>
  <li>即时通讯、课程进度相关功能（以实际开通为准）；</li>
  <li>优惠券、邀请活动等运营活动（以活动页面规则为准）。</li>
</ul>
<p>我们可能根据业务需要调整、暂停或终止部分功能，并将尽可能通过公告、站内通知等方式告知。</p>

<h2>四、课程交易与费用</h2>
<ul>
  <li>课程价格、课时、服务范围以订单页展示为准。</li>
  <li>您应通过平台支持的支付方式完成付款；支付成功后订单按平台规则进入相应状态。</li>
  <li>退款、取消、结课、评价等规则以订单页面说明及客服处理结果为准。</li>
  <li>教师端入驻、分成、结算等规则以教师协议及后台说明为准。</li>
</ul>

<h2>五、用户行为规范</h2>
<p>您不得利用本平台从事以下行为：</p>
<ul>
  <li>发布违法违规、侵权、虚假或不当内容；</li>
  <li>骚扰、辱骂老师、学生或其他用户；</li>
  <li>规避平台私下交易以逃避监管或费用；</li>
  <li>破解、爬取、攻击平台系统或干扰服务正常运行；</li>
  <li>其他违反法律法规或诚实信用原则的行为。</li>
</ul>

<h2>六、知识产权</h2>
<p>本平台中的软件、界面、文案、标识、课程介绍等内容，除另有说明外，其知识产权归我们或权利人所有。未经许可，您不得擅自复制、传播、修改或用于商业用途。</p>

<h2>七、免责声明</h2>
<ul>
  <li>考学结果受个人基础、学习投入、院校政策等多种因素影响，本平台不保证录取或特定成绩。</li>
  <li>因不可抗力、网络故障、第三方服务异常导致的服务中断或延误，我们将尽力协助处理，但不承担超出法律规定的责任。</li>
  <li>您与老师之间的教学沟通内容由双方自行负责；涉及违法违规的，我们将依法配合处理。</li>
</ul>

<h2>八、协议变更与终止</h2>
<p>我们可能适时修订本条款。修订后将在本页面公布，公布后继续使用即视为接受修订。您可随时停止使用本平台；我们也可在必要时终止向您提供服务。</p>

<h2>九、适用法律与争议解决</h2>
<p>本条款适用中华人民共和国法律（不含冲突规范）。因本条款引起的争议，双方应友好协商；协商不成的，提交我们住所地有管辖权的人民法院解决。</p>

<h2>十、联系我们</h2>
<p>如对本服务条款有疑问，请通过 App 内反馈/客服入口与我们联系。</p>
`

export default {
  name: 'LegalTermsPage',
  components: { LegalDocPage },
  data() {
    return { html }
  },
}
</script>
